import { Stack as t } from "@mui/material";
import { styled as o } from "./styled2.mjs";
const r = o(t)`
	gap: 6px;
`;
export {
  r as Stack
};
//# sourceMappingURL=styles89.mjs.map
